<template>
  <div class="signup">
    <div class="signup__content">
      <form
        class="signup__form container pa-0 grid-list-lg"
        @submit.prevent="submit"
        @keyup.enter="submit"
      >
        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Имя и Фамилия:</div>
          </div>
          <div class="flex xs6 sm4 form-fields">
            <input
              v-model="$v.form.first_name.$model"
              type="text"
              class="form-input"
              :class="{ invalid: isInvalid('first_name') }"
              placeholder="Введите имя"
            />
          </div>
          <div class="flex xs6 sm4 form-fields">
            <input
              v-model="$v.form.last_name.$model"
              type="text"
              class="form-input"
              :class="{ invalid: isInvalid('last_name') }"
              placeholder="Введите фамилию"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Город:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              type="text"
              class="form-input"
              :class="{ invalid: isInvalid('city') }"
              placeholder="Введите Город"
              v-model="$v.form.city.$model"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Телефон</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              type="text"
              class="form-input"
              :class="{ invalid: isInvalid('mobile_number') }"
              placeholder="Введите телефон"
              v-mask="'+7 (###) ###-##-##'"
              v-model="$v.form.mobile_number.$model"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">E-mail:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              type="email"
              class="form-input"
              :class="{ invalid: isInvalid('email') }"
              placeholder="Введите E-mail"
              v-model="$v.form.email.$model"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Пароль:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              type="password"
              class="form-input"
              :class="{ invalid: isInvalid('password') }"
              placeholder="Введите пароль"
              v-model="$v.form.password.$model"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 offset-sm4 sm8">
            <FormSwitch v-model="$v.form.confirmAge.$model">
              <template #label>
                <div class="form-text">
                  <p>
                    Я подтверждаю, что мне исполнилось 16 лет и согласен с
                    <a
                      target="_blank"
                      @click.stop=""
                      href="/uploads/River_Runes_Terms&Conditions.pdf?v=2"
                    >
                      Условиями участия.
                    </a>
                  </p>
                </div>
              </template>
            </FormSwitch>
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 offset-sm4 sm8">
            <FormSwitch v-model="$v.form.agreement.$model">
              <template #label>
                <div class="form-text">
                  <p>
                    Я даю свое добровольное согласие на предоставление и
                    дальнейшую обработку моих персональных данных ООО «Ред Булл
                    (Рус)» в соответствии с целями, перечисленными в
                    <a
                      target="_blank"
                      @click.stop=""
                      href="https://policies.redbull.com/policies/RedBull.com_Russia/201907010152/ru/privacy.html"
                    >
                      Положении о конфиденциальности компании Red Bull.
                    </a>
                  </p>
                </div>
              </template>
            </FormSwitch>
          </div>
        </div>

        <div class="flex xs12 form-row layout row align-center justify-center">
          <AppBtn
            :loading="loading"
            round
            color="orange-grad"
            class="px-4"
            type="submit"
            @click="submit()"
          >
            <span>Зарегистрироваться</span>
          </AppBtn>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getValidationMessage } from "@utils/validation-messages";
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import { requestAlert, showAlert } from "@/services/common/showAlert";
import { asyncModal } from "@/components/ui/modal/";

import { mapActions, mapGetters } from "vuex";
import { VueMaskDirective } from "v-mask";
import FormSwitch from "@/components/ui/form/FormSwitch";
// import { openModal as openPasswordRecoverModal } from "./PasswordRecover";

const defaultForm = () => ({
  email: "",
  password: "",
  mobile_number: "",
  first_name: "",
  last_name: "",
  city: "",
  // repeatPassword: "",
  // middle_name: "",
  // birthday: "",
  confirmAge: false,
  agreement: false
});

const Signup = {
  name: "Signup",
  components: { FormSwitch },
  directives: { mask: VueMaskDirective },

  data: () => ({
    form: defaultForm(),
    loading: false,
    formErrors: {},
    message: ""
  }),

  validations: {
    form: {
      first_name: { required },
      last_name: { required },
      mobile_number: { required },
      city: { required },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      confirmAge: { sameAs: sameAs(() => true) },
      agreement: { sameAs: sameAs(() => true) }
      // middle_name: { required },
      // birthday: { required },
      // repeatPassword: { sameAs: sameAs("password") }
    }
  },

  computed: {
    toSend() {
      return {
        ...this.form,
        mobile_number: this.form.mobile_number.replace(/[^+0-9]+/g, "")
      };
    },
    ...mapGetters("contest", ["isAuthenticated"])
  },

  methods: {
    ...mapActions("contest", ["signup"]),

    getError(field) {
      return getValidationMessage(this.$v.form[field]);
    },

    isInvalid(field) {
      return this.$v.form[field].$error;
    },

    async submit() {
      if (this.loading) return;
      this.formErrors = {};
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const { success, message, data } = await this.signup(this.toSend);
        if (success) {
          await showAlert("Вы успешно зарегистрировались на сайте!");
          this.form = defaultForm();
          this.$modals.close(this.isAuthenticated);
        } else {
          this.formErrors = data || {};
          requestAlert(message || undefined, data || []);
        }
      } catch (e) {
        requestAlert();
        console.log(e);
      }
      this.loading = false;
    }
  }
};

export default Signup;

export function openModal() {
  return asyncModal({
    name: "signup-modal",
    component: Signup,
    title: "Регистрация"
  });
}
</script>
